import { render, staticRenderFns } from "./xpTransfer.vue?vue&type=template&id=22539092&scoped=true&"
import script from "./xpTransfer.vue?vue&type=script&lang=js&"
export * from "./xpTransfer.vue?vue&type=script&lang=js&"
import style0 from "./xpTransfer.vue?vue&type=style&index=0&id=22539092&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22539092",
  null
  
)

export default component.exports